import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { Carousel } from '@one-thd/sui-carousel';
import { AssistantProductPod } from './AssistantProductPod';

const carouselBreakpoints = {
  sm: {
    slidesPerView: 2,
    slidesPerGroup: 2
  },
  md: {
    slidesPerView: 2,
    slidesPerGroup: 2
  },
  lg: {
    slidesPerView: 2,
    slidesPerGroup: 2
  },
  xl: {
    slidesPerView: 2,
    slidesPerGroup: 2
  },
  '2xl': {
    slidesPerView: 2,
    slidesPerGroup: 2
  }
};

const AssistantRecommendations = ({ products }) => {
  const impressionData = {
    id: '',
    name: 'MagicApronAssistant',
    component: 'MagicApronAssistant',
    recType: 'best matches',
    type: 'product',
    category: 'BestMatches', // TODO: Refactor once Carousel with tabs is implemented
    position: '',
  };

  if (products.length > 1) {
    return (
      <ImpressionProvider data={impressionData}>
        <Carousel
          data-testid="maa-product-carousel"
          breakpoints={carouselBreakpoints}
        >
          {products.map(({ itemId }, index) => (
            <AssistantProductPod itemId={itemId} key={itemId} disablePadding index={index} />
          ))}
        </Carousel>
      </ImpressionProvider>
    );
  }

  return (
    <ImpressionProvider data={impressionData}>
      <div data-testid="maa-product">
        <AssistantProductPod
          itemId={products[0].itemId}
        />
      </div>
    </ImpressionProvider>
  );
};

AssistantRecommendations.propTypes = {
  products: arrayOf(shape({
    itemId: string
  })).isRequired
};

AssistantRecommendations.dataModel = extend(AssistantProductPod);

export { AssistantRecommendations };